import type { SVGProps } from "react";
import { memo } from "react";
const ElementalMediaPackage = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 80 80" {...props}>
    <defs>
      <linearGradient id="prefix__a" x1="0%" x2="100%" y1="100%" y2="0%">
        <stop offset="0%" stopColor="#C8511B" />
        <stop offset="100%" stopColor="#F90" />
      </linearGradient>
    </defs>
    <g fill="none" fillRule="evenodd">
      <path fill="url(#prefix__a)" d="M0 0h80v80H0z" />
      <path
        fill="#FFF"
        d="M26 48.382v-5.764l5-2.5 5 2.5v5.764l-5 2.5zm28-5.764v5.764l-5 2.5-5-2.5v-5.764l5-2.5zm8 8.765-6-2.994v-6.39a1 1 0 0 0-.553-.893l-6-3a1 1 0 0 0-.894 0l-6 3A1 1 0 0 0 42 42v7c0 .379.214.725.553.895l6 3c.281.14.613.14.894 0l5.545-2.773 5.943 2.965L41 65.22V55h-2V65.22L19.064 53.086 25 50.118l5.553 2.777a1 1 0 0 0 .894 0l6-3c.339-.17.553-.516.553-.895v-7a1 1 0 0 0-.553-.894l-6-3a1 1 0 0 0-.894 0l-6 3A1 1 0 0 0 24 42v6.382l-6 3V28.766l8.485 5.092 1.03-1.715-8.529-5.117L39 15.713v6.669l-5.447 2.724A1 1 0 0 0 33 26v7a1 1 0 0 0 .55.893l6 3.023c.283.142.617.142.9 0l6-3.023A1 1 0 0 0 47 33v-7a1 1 0 0 0-.553-.894L41 22.382v-6.733l20.003 10.437-9.54 6.07 1.074 1.688L62 27.822zM40 24.118l5 2.5v5.766l-5 2.519-5-2.52v-5.765zm23.463.995-23-12a1 1 0 0 0-.955.016l-23 13A1 1 0 0 0 16 27v26a1 1 0 0 0 .48.855l23 14a1 1 0 0 0 1.04 0l23-14A1 1 0 0 0 64 53V26c0-.372-.207-.714-.537-.887"
      />
    </g>
  </svg>
);
const Memo = memo(ElementalMediaPackage);
export default Memo;
